import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import cns from 'classnames';
import { Field } from 'redux-form';
import { v4 as uuid } from 'uuid';
import BasicText from '../../../../../shared/components/formComponents/groups/BasicText';
import BasicSelect from '../../../../../shared/components/formComponents/groups/BasicSelect';
import ImageUpload from '../../../../../shared/components/formComponents/inputs/ImageUpload';
import VerbHeading from '../../../../../shared/components/VerbHeading';
import VerbButton from '../../../../../shared/components/VerbButton';
import { ASSET_METADATA_LOOKUP, ASSET_METADATA_CATEGORIES } from '../../../../../shared/Constants';

const metadataArray = Object.values(ASSET_METADATA_LOOKUP).map((metadataItem) => {
    const newLabel = `${metadataItem.label} - ${ASSET_METADATA_CATEGORIES[metadataItem.categoryId].label}`;
    metadataItem.label = newLabel;
    return metadataItem;
});

export class ChoosePathOption extends Component {
    static propTypes = {
        fields: PropTypes.any,
        contentValues: PropTypes.shape({
            displayType: PropTypes.string,
            options: PropTypes.array
        }),
        disabled: PropTypes.bool,
        metadataActive: PropTypes.bool,
        handleRoleDelete: PropTypes.func,
        handleRoleChange: PropTypes.func
    };

    addField = () => {
        const fieldObject = {
            label: '',
            image: '',
            choice: '',
            id: uuid()
        };

        this.props.fields.push(fieldObject);
    };

    removeField = (i, id) => {
        const { handleRoleDelete } = this.props;
        handleRoleDelete(id);
        this.props.fields.remove(i);
    };

    moveUp = (i) => {
        if (i) {
            this.props.fields.swap(i, i - 1);
        }
    };

    moveDown = (i) => {
        if (i < this.props.fields.length - 1) {
            this.props.fields.swap(i, i + 1);
        }
    };

    roleOnChange = (id) => (e, val) => {
        const { handleRoleChange } = this.props;
        return handleRoleChange(id, val);
    };

    render() {
        const {
            fields,
            disabled,
            metadataActive = false,
            contentValues: { displayType, options }
        } = this.props;

        const fieldsArray = fields.map((name, idx) => {
            const key = options[idx].id;

            const { isOther } = options[idx];
            return (
                <div key={key} className={'chooseSectionItem-optionInput col-12 row'}>
                    {displayType === 'image' ? (
                        <Field
                            name={`${name}.image`}
                            className={cns('col-7', { hidden: isOther })}
                            cropProp={{ width: 150, height: 150 }}
                            component={ImageUpload}
                            disabled={disabled}
                        />
                    ) : null}
                    <div className={displayType === 'image' ? 'col-md-5 row' : 'col-12 row'}>
                        {!disabled && !isOther ? (
                            <div className={'col-md-offset-6 col-md-6 optionButtons ms-auto'}>
                                <Button onClick={() => this.moveUp(idx)} className={'col-4 chooseSectionItem-swapUp'}>
                                    <i className={'fa fa-angle-up'} />
                                </Button>
                                <Button
                                    onClick={() => this.moveDown(idx)}
                                    className={'col-4 chooseSectionItem-swapDown'}
                                >
                                    <i className={'fa fa-angle-down'} />
                                </Button>
                                <Button
                                    onClick={() => this.removeField(idx, options[idx].id)}
                                    className={'col-4 chooseSectionItem-delete'}
                                >
                                    <i className={'fa fa-trash'} />
                                </Button>
                            </div>
                        ) : null}
                        <div className={'col-12'}>
                            <div className={'row'}>
                                <Field
                                    name={`${name}.label`}
                                    placeholder={'Enter option text.'}
                                    className={'col-6'}
                                    component={BasicText}
                                    rows={2}
                                    props={{ disabled }}
                                />
                                <Field
                                    name={`${name}.choice`}
                                    placeholder={'Enter the role for this option.'}
                                    className={'col-6'}
                                    onChange={this.roleOnChange(options[idx].id)}
                                    component={BasicText}
                                />
                            </div>
                        </div>
                        <VerbHeading
                            className={cns({ hidden: !['radio', 'box'].includes(displayType) })}
                            defaultMessage={'"Other" option included in list'}
                            hNumber={4}
                        />
                        {metadataActive ? (
                            <Field
                                name={`${name}.metadataTag`}
                                className={'col-12'}
                                component={BasicSelect}
                                label={'Metadata'}
                                options={metadataArray}
                                labelKey={'label'}
                                valueKey={'id'}
                            />
                        ) : null}
                    </div>
                </div>
            );
        });
        return (
            <div className={'chooseSectionItem-optionFields col-12'}>
                <div className={'row'}>{fieldsArray}</div>
                {!disabled ? (
                    <div>
                        <div className={'row'}>
                            <VerbButton
                                className={'col-4 choose-option-add-field'}
                                fontAwesomeIcon={'fa-plus'}
                                onClick={() => this.addField()}
                            >
                                Add New Option
                            </VerbButton>
                        </div>
                    </div>
                ) : null}
                <br />
            </div>
        );
    }
}

export default ChoosePathOption;
